module.exports = __webpack_public_path__ + "img/9788970636085.d38aafbf.jpg";